const taxEn = {
  "settings.taxes": "Taxes & duties",
  "settings.taxes_hint": "VAT rates, registrations and how tax is calculated",
  "tax.advisor": "Default rates are provided for convenience. Confirm them with your tax advisor before you start selling.",
  "tax.countries": "Where you collect tax",
  "tax.countries_hint": "Turn on collecting for each country where you're registered for VAT. Customers shipping there are charged the rate shown.",
  "tax.add_country": "Add country",
  "tax.add_country_hint": "You'll collect tax for orders shipped to this country. Add your registration number next.",
  "tax.country_added": "Collecting tax in {country}.",
  "tax.collect": "Collect",
  "tax.stop": "Stop collecting",
  "tax.collecting": "Collecting",
  "tax.not_collecting": "Not collecting",
  "tax.no_rate": "No default rate — set one",
  "tax.custom_rate": "custom rate",
  "tax.add_number": "add your registration number",
  "tax.n_overrides": "{n} overrides",
  "tax.collect_in": "Collect tax in {country}",
  "tax.number": "VAT / TRN registration number",
  "tax.number_hint": "Shown on invoices. Required to charge VAT in most GCC countries.",
  "tax.name_on_registration": "Name on registration",
  "tax.effective_from": "Registered from",
  "tax.rate": "Rate",
  "tax.rate_hint_default": "Leave empty to use the default ({rate}%).",
  "tax.rate_hint_none": "There's no default rate for this country; enter the rate you charge.",
  "tax.calculation": "Calculation",
  "tax.prices_include": "Prices include tax",
  "tax.prices_include_hint": "The usual way in the GCC: the price you enter is what customers pay, VAT included.",
  "tax.shipping": "Charge tax on shipping",
  "tax.shipping_hint": "VAT applies to delivery charges in the UAE, KSA, Bahrain and Oman.",
  "tax.rounding": "Rounding",
  "tax.rounding.per_line": "Round each line (default)",
  "tax.rounding.per_invoice": "Round once per invoice",
  "tax.display": "Storefront prices",
  "tax.display.inclusive": "Show prices with tax",
  "tax.display.exclusive": "Show prices before tax",
  "tax.overrides": "Overrides",
  "tax.overrides_hint": "Charge a different rate for some products, collections or shipping, e.g. zero-rated items.",
  "tax.add_override": "Add override",
  "tax.no_overrides": "No overrides. Every product uses its country's rate.",
  "tax.delete_override": "Delete this override?",
  "tax.applies_to": "Applies to",
  "tax.scope.product": "Product",
  "tax.scope.collection": "Collection",
  "tax.scope.shipping": "Shipping",
  "tax.scope.country": "Region of a country",
  "tax.scope.region": "Region {region}",
  "tax.search_products": "Search products",
  "tax.search_collections": "Search collections",
  "tax.no_matches": "No matches.",
  "tax.change": "Change",
  "tax.region": "Region code",
  "tax.region_required": "Needed for regional rates.",
  "tax.tax_name": "Tax name",
  "tax.calculator": "Tax calculator",
  "tax.calculator_hint": "Check what a customer would pay with your current settings.",
  "tax.ship_to": "Ship to",
  "tax.shipping_amount": "Shipping",
  "tax.order_discount": "Order discount",
  "tax.customer_exempt": "Tax-exempt customer",
  "tax.calculate": "Calculate",
  "tax.not_collecting_banner": "You're not collecting tax in {country}, so no tax is charged.",
  "tax.col.item": "Item",
  "tax.col.net": "Amount",
  "tax.col.rate": "Tax",
  "tax.col.tax": "Tax amount",
  "tax.discount_of": "{amount} discount",
  "tax.subtotal": "Subtotal",
  "tax.included": "included",
  "tax.total": "Total",
  "tax.why.not_collecting": "Not collecting here",
  "tax.why.not_taxable": "Not taxable",
  "tax.why.exempt": "Exempt",
  "tax.why.customer_exempt": "Customer exempt",
  "tax.why.shipping_not_taxed": "Shipping not taxed",
} as const;

export default taxEn;
